(function () {
  "use strict";

  function clean() {
    var root = document.querySelector("[data-alunir-booking-handle]");
    if (!root) return;
    var blocks = root.closest("[data-product-blocks]");
    if (!blocks) return;

    var legacyFragments = [
      "Starter-Set: Armband CHF 22",
      "Permanent Bracelet: Armband",
      "Eine Person pro Termin",
      "Viele verschiedene Anhänger",
      "Zahlung erfolgt vor Ort",
      "1 Jahr Garantie",
    ];
    blocks.querySelectorAll(".product-block").forEach(function (block) {
      if (block === root || block.contains(root)) return;
      var text = (block.textContent || "").replace(/\s+/g, " ");
      if (legacyFragments.some(function (fragment) { return text.indexOf(fragment) !== -1; })) {
        block.hidden = true;
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", clean);
  else clean();
})();
